import React from "react";
import MobileFeatures from "./MobileFeatures";
import DesktopFeatures from "./DesktopFeatures";
import { Link } from "@reach/router";
import simboloPrimary from "../../assets/rebrand/simbolo-primary.png";

const LandingFeatures = () => {
  return (
    <div id="features" className="container-fluid">
      <div className="row align-items-start mx-0">
        <div className="col-12 col-lg-4 mb-4">
          <h3 className="h1 mb-3">Cumple tus metas</h3>
          <p className="large">
            Todo lo que necesitas para llevar tu práctica al siguiente nivel y empezar a construir un camino profesional haciendo lo que amas.
          </p>
          <p className="large">
             Porque dominar tu técnica no solo fortalece tu práctica: también te da las herramientas para dirigir entrenamientos eficientes y con resultados, enseñar con claridad, conectar con tus alumnas y crear más que una clase: una experiencia que construye comunidad.
          </p>
          <ul className="mb-5 large list-unstyled">
            <li className="d-flex align-items-center mb-2">
              <img
                src={simboloPrimary}
                alt=""
                aria-hidden="true"
                width="16"
                height="16"
                className="me-2"
              />
              <span>La técnica no limita tu creatividad, la fortalece.</span>
            </li>
            <li className="d-flex align-items-center mb-2">
              <img
                src={simboloPrimary}
                alt=""
                aria-hidden="true"
                width="16"
                height="16"
                className="me-2"
              />
              <span>El método no apaga tu energía; la dirige.</span>
            </li>
            <li className="d-flex align-items-center">
              <img
                src={simboloPrimary}
                alt=""
                aria-hidden="true"
                width="16"
                height="16"
                className="me-2"
              />
              <span>
                La independencia real es la capacidad de generar tus propios
                ingresos haciendo algo que dominas.
              </span>
            </li>
          </ul>
          <Link to="/courses" className="btn btn-primary">
            Ver certificaciones
          </Link>
        </div>
        <div className="col-12 col-lg-8 mb-3">
          <div className="d-lg-none d-md-none">
            {/* <!-- Carousel for mobile devices --> */}
            <MobileFeatures />
          </div>
          <div className="d-none d-md-block d-lg-block">
            <DesktopFeatures />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingFeatures;
